import request from '@/utils/request'

// 查询类目列表
export function listTableCategory(data) {
  return request({
    url: '/sysGoodsCategory/list',
    method: 'post',
    data,
  })
}

// 新增类目
export function addTable(data) {
  return request({
    url: '/sysGoodsCategory/add',
    method: 'post',
    data: data,
  })
}

// 修改类目
export function updateTable(data) {
  return request({
    url: '/sysGoodsCategory/upd',
    method: 'post',
    data: data,
  })
}

// 删除类目
export function delTable(data) {
  return request({
    url: `/sysGoodsCategory/delete/?id=${data}`,
    method: 'get',
  })
}
